import React, { Component } from "react";
import PropTypes from "prop-types";

import * as actions from "../../../redux/modules/actions";

import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  ButtonGroup,
} from "react-bootstrap";
import renderHTML from "react-render-html";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Dialog from "react-bootstrap-dialog";
import { getCustomPage, CustomPageDelete } from "../../../redux/actions/designCenterActions";
import {
  renderAlert,
  clearAlert,
  alertsActions
} from "../../../redux/actions/alertsActions";
import "../../../style/listPage.scss";
import {aclUtil} from "../../util"

const history = createBrowserHistory();

class CustomPage extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'LIST_CUSTOMPAGE',
      custompageList: [],
      activePage: 1,
      totalRecords: 0,
      loading: true,
      limit: 100,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      path: ["Home", "Custom Page List"],
      links:['home','asset/custompage/list'],
      show: false,
      reasonForExecution: "",
      offerReasonForExecutionError: "",
      alert: false,
      orderby: "",
      direction: "",
      siteDomain:location.protocol + '//' + location.host,
    };

    this.handleDismiss = this.handleDismiss.bind(this);
  }

  componentDidMount() { 
    this.props.getCustomPage({ page: this.state.activePage, limit: this.state.limit });
    if (this.props.error) {
      this.setState({ loading: false });
    }
    let siteDDBStatus = JSON.parse(localStorage.getItem('siteDDBStatus'));  
    let siteDomain = (siteDDBStatus.siteDomain ? siteDDBStatus.siteDomain : ''); 
    this.setState({siteDomain: location.protocol + '//' + location.host});
  }

  hadnlePageChange(){ 
    this.props.getCustomPage({ page: this.state.activePage, limit: this.state.limit });
    if (this.props.error) {
      this.setState({ loading: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    } 
    if (nextProps.custompageList.data) {
      let resData = nextProps.custompageList.data;
      let setPageCount = resData.total / resData.per_page;
      this.setState({
        custompageList: resData.data,
        currentPage: resData.current_page,
        from: resData.from,
        last_page: resData.last_page,
        perPage: resData.per_page,
        to: resData.to,
        totalRecords: resData.total,
        pageCount: setPageCount
      });
    }
    if(this.props.delete !== nextProps.delete){
      if(nextProps.delete){
        if (nextProps.delete.response == 'success') {
          this.hadnlePageChange();
        }
      }
    }
    
    if (nextProps.custompageList || nextProps.error) {
      this.setState({ loading: false });
    }
  }

  displaySource = dcData => {
    if (dcData.background_type == 1) {
      return (
        '<img src="' +
        dcData.display_image +
        '" style="width:auto; max-height:80px" />'
      );
    } else {
      return (
        '<div style="width:100px; background:' +
        dcData.background_color +
        '; height:35px">' +
        dcData.background_color +
        "<div>"
      );
    }
  };

  handleDelete = custom_id => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(custom_id);
          this.handleShow();
        })
      ]
    });
  };

  handleShow() {
    this.setState({ show: true });
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  confirmDelete = custom_id => { 
    this.props.CustomPageDelete(custom_id);
  };

  stringUCWord(str) {
    if (str) {
      str = str.replace(/_/g, " ");
      let sText = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
      });
      return sText;
    }
  }

  render() {
    const {
      currentPage,
      totalRecords,
      perPage,
      pageCount,
      custompageList
    } = this.state;
    let contentRow;
    if (!isEmpty(custompageList)) {
      contentRow = custompageList.map((dc, index) => (
        <tr key={dc.custom_id}> 
          <td>{this.stringUCWord(dc.custom_page_name)}</td>
          <td>{dc.description}</td>
          <td>{dc.is_homepage==1 ? 'Yes' : 'No'}</td>
          <td>{dc.url ? (this.state.siteDomain + '/page/' + dc.url) : ''}</td> 
          <td>
            <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL('EDIT_CUSTOMPAGE') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/asset/custompage/edit/${dc.custom_id}`)}><i className="glyphicon glyphicon-pencil"></i> Edit</MenuItem>):("")}
                  {aclUtil.checkACL('DELETE_CUSTOMPAGE') ? (<MenuItem eventKey={Math.random()} onClick={this.handleDelete.bind(this, dc.custom_id)}><i className="glyphicon glyphicon-trash"></i> Delete</MenuItem>):("")}
                </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }

    return (
      <div>
        {this.state.loading === true ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />

        <div className="col-lg-12 user-list list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
              {/*<Button
                bsSize="xsmall"
                bsStyle="success"
                onClick={() => this.context.router.history.push("/assets/color/list")}
              >
                {" "}
                Assets Color Listing{" "}
              </Button>*/}
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Custom Page List</header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              {aclUtil.checkACL('ADD_CUSTOMPAGE') ? (
              <div className="row">
                <div className="col-lg-12 text-right">
                  <Button
                    bsSize="small"
                    bsStyle="success"
                    onClick={() => this.context.router.history.push("/asset/custompage/add")}
                  >
                    + Add Custom Page
                  </Button>
                </div>
              </div>
              ):("")}
              <div className="clearfix" />

              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th> Custom Page Name </th>
                        <th> Description </th>
                        <th> Set As Home Page </th>
                        <th> URL </th> 
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>{contentRow}</tbody>
                  </table>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.designCenterReducer.loading,
    error: state.designCenterReducer.error,
    custompageList: state.designCenterReducer.custompageList,
    alertType: state.alertsReducer.alertType,
    delete: state.designCenterReducer.delete,
    message: state.alertsReducer.message
  };
};
 

export default withRouter(connect(mapStateToProps, {getCustomPage, CustomPageDelete})(CustomPage));



// WEBPACK FOOTER //
// ./src/app/views/admin/designCenter/CustomPage.js